import { AuthAside } from "../../../auth/AuthAside";

export default function Left() {
  return (
    <>
      <AuthAside />
    </>
  );
}
